/* ================================================
   CANDy BLOOD - Main JavaScript
   Scroll-telling Website for Leather Crafting
   ================================================ */

console.log("🍬 Main.js file is loading...");

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger);

// Configure ScrollTrigger for better scroll performance
ScrollTrigger.config({
  anticipatePin: 1,
  autoRefreshEvents: "visibilitychange,DOMContentLoaded,load"
});

// Normalize scroll behavior across devices
ScrollTrigger.normalizeScroll(true);

// Check if ScrollTo plugin is available
if (typeof ScrollToPlugin !== 'undefined') {
  gsap.registerPlugin(ScrollToPlugin);
}

// Global configuration
const config = {
  animationEnabled: true,
  smoothScroll: true,
  debug: false
};

// Wait for DOM to be ready
console.log("🍬 Main.js loaded - waiting for DOM");

document.addEventListener("DOMContentLoaded", () => {
  console.log("🍬 DOM Content Loaded");
  // Initialize all sections
  initApp();
});

function initApp() {
  // Initialize navigation
  initNavigation();

  // Initialize each section (loaded from separate files)
  if (typeof initHeroSection === "function") initHeroSection();
  if (typeof initStorySection === "function") initStorySection();
  if (typeof initCraftSection === "function") initCraftSection();
  if (typeof initProductsSection === "function") initProductsSection();
  if (typeof initFooterSection === "function") initFooterSection();

  // Initialize smooth scroll links
  initSmoothScrollLinks();

  // Handle window resize
  initResizeHandler();

  // Preload images for better performance
  preloadImages();

  // Initialize page transition on bottom scroll
  initPageTransition();

  // Initialize zoom and viewport monitoring
  initZoomMonitor();

  console.log("🍬 CANDy BLOOD - Website Initialized");
}

// Navigation functionality
function initNavigation() {
  const nav = document.querySelector(".main-nav");
  const menuToggle = document.querySelector(".menu-toggle");
  const navMenu = document.querySelector(".nav-menu");

  if (!nav) return;

  // Mobile menu toggle
  if (menuToggle && navMenu) {
    menuToggle.addEventListener("click", () => {
      menuToggle.classList.toggle("active");
      navMenu.classList.toggle("active");
      document.body.classList.toggle("menu-open");
    });

    // Close menu on link click
    navMenu.querySelectorAll("a").forEach(link => {
      link.addEventListener("click", () => {
        menuToggle.classList.remove("active");
        navMenu.classList.remove("active");
        document.body.classList.remove("menu-open");
      });
    });
  }

  // Hide nav on scroll down, show on scroll up
  let lastScroll = 0;
  let ticking = false;
  const navHeight = nav.offsetHeight;
  const scrollThreshold = 50; // Minimum scroll amount to trigger hide/show

  function updateNav() {
    const currentScroll = window.pageYOffset;

    // At the very top - always show nav, remove all classes
    if (currentScroll <= 0) {
      nav.classList.remove("nav-hidden");
      nav.classList.remove("nav-visible");
      nav.classList.remove("scrolled");
      lastScroll = currentScroll;
      ticking = false;
      return;
    }

    const scrollDelta = currentScroll - lastScroll;

    // Only trigger if scroll amount exceeds threshold
    if (Math.abs(scrollDelta) > scrollThreshold) {
      if (scrollDelta > 0 && currentScroll > navHeight) {
        // Scrolling down - hide nav
        nav.classList.add("nav-hidden");
        nav.classList.remove("nav-visible");
      } else if (scrollDelta < 0) {
        // Scrolling up - show nav
        nav.classList.remove("nav-hidden");
        nav.classList.add("nav-visible");
      }
      lastScroll = currentScroll;
    }

    // Add scrolled class when past hero (for background)
    if (currentScroll > window.innerHeight * 0.3) {
      nav.classList.add("scrolled");
    } else {
      nav.classList.remove("scrolled");
    }

    ticking = false;
  }

  window.addEventListener("scroll", () => {
    if (!ticking) {
      requestAnimationFrame(updateNav);
      ticking = true;
    }
  }, { passive: true });
}

// Smooth scroll for anchor links
function initSmoothScrollLinks() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener("click", function (e) {
      const targetId = this.getAttribute("href");
      if (targetId === "#") return;

      const target = document.querySelector(targetId);
      if (!target) return;

      e.preventDefault();

      const navHeight = document.querySelector(".main-nav")?.offsetHeight || 0;
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - navHeight;

      if (typeof gsap.to === "function") {
        gsap.to(window, {
          scrollTo: { y: targetPosition, autoKill: false },
          duration: 1.2,
          ease: "power3.inOut"
        });
      } else {
        window.scrollTo({
          top: targetPosition,
          behavior: "smooth"
        });
      }
    });
  });
}

// Handle resize for ScrollTrigger
function initResizeHandler() {
  let resizeTimer;

  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      ScrollTrigger.refresh();
    }, 250);
  });
}

// Monitor zoom and viewport information
function initZoomMonitor() {
  console.log("🔍 Zoom monitor initialized");

  function logViewportInfo() {
    console.log('=== 🔍 Viewport & Zoom Info ===');
    console.log('Window Inner Width:', window.innerWidth + 'px');
    console.log('Window Inner Height:', window.innerHeight + 'px');
    console.log('Device Pixel Ratio:', window.devicePixelRatio);
    console.log('Document Client Width:', document.documentElement.clientWidth + 'px');
    console.log('Approximate Zoom:', Math.round((window.outerWidth / window.innerWidth) * 100) + '%');
    console.log('Screen Width:', window.screen.width + 'px');
    console.log('Screen Height:', window.screen.height + 'px');
    console.log('============================');
  }

  // Log initial state
  logViewportInfo();

  // Log on resize/zoom
  window.addEventListener('resize', debounce(logViewportInfo, 500));
}

// Preload images for smoother animations
function preloadImages() {
  const resolveAssetUrl = (filename) => {
    if (window.shopifyAssetUrls && typeof window.shopifyAssetUrls.assetUrl === "function") {
      return window.shopifyAssetUrls.assetUrl(filename);
    }

    return filename;
  };

}

// Utility: Check if element is in viewport
function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

// Utility: Debounce function
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Utility: Throttle function
function throttle(func, limit) {
  let inThrottle;
  return function (...args) {
    if (!inThrottle) {
      func.apply(this, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
}

// Page Transition on Bottom Scroll
function initPageTransition() {
  // Debug: Add ?notransition to URL to disable page transition
  if (window.location.search.includes('notransition')) {
    console.log('Page transition disabled for debugging');
    return;
  }

  const indicator = document.querySelector(".page-transition-indicator");
  const progressBar = document.querySelector(".page-transition-indicator .progress-bar");
  const hint = document.querySelector(".page-transition-hint");
  const overlay = document.querySelector(".page-transition-overlay");

  if (!indicator || !progressBar || !hint || !overlay) return;

  const targetUrl = "https://kawa-ii.jp/collections/all";
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const scrollThreshold = isMobile ? 80 : 150; // Lower threshold for mobile
  const bottomThreshold = isMobile ? 50 : 5; // More tolerance for mobile
  let accumulatedScroll = 0;
  let isAtBottom = false;
  let transitionTriggered = false;
  let lastScrollTop = 0;
  let decayTimer = null;
  // Touch variables (declared early for resetTransitionState)
  let touchStartY = 0;
  let touchMoveAccumulated = 0;
  let isTouchingAtBottom = false;

  // Reset transition state (for browser back button)
  function resetTransitionState(scrollToTop = false) {
    transitionTriggered = false;
    accumulatedScroll = 0;
    touchMoveAccumulated = 0;
    isTouchingAtBottom = false;
    overlay.classList.remove("active");
    indicator.classList.remove("visible");
    hint.classList.remove("visible");
    progressBar.style.width = "0%";
    document.body.style.overflow = "";
    if (scrollToTop) {
      window.scrollTo(0, 0);
    }
  }

  // Handle page show event (fires on back/forward navigation)
  window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
      // Page was restored from bfcache (back/forward cache)
      resetTransitionState(true);
    }
  });

  // Reset on initial load (without scrolling to top)
  resetTransitionState(false);

  function isScrolledToBottom() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    // Consider "at bottom" with tolerance (more for mobile due to bounce scrolling)
    return scrollTop + windowHeight >= documentHeight - bottomThreshold;
  }

  function updateProgress(progress) {
    const clampedProgress = Math.min(Math.max(progress, 0), 100);
    progressBar.style.width = clampedProgress + "%";
  }

  function showIndicator() {
    indicator.classList.add("visible");
    hint.classList.add("visible");
  }

  function hideIndicator() {
    indicator.classList.remove("visible");
    hint.classList.remove("visible");
  }

  function triggerTransition() {
    if (transitionTriggered) return;
    transitionTriggered = true;

    // Show overlay
    overlay.classList.add("active");
    document.body.style.overflow = "hidden";

    // Redirect after animation
    setTimeout(() => {
      window.location.href = targetUrl;
    }, 1500);
  }

  function decayAccumulatedScroll() {
    if (accumulatedScroll > 0 && !isAtBottom) {
      accumulatedScroll = Math.max(0, accumulatedScroll - 3);
      updateProgress((accumulatedScroll / scrollThreshold) * 100);

      if (accumulatedScroll > 0) {
        decayTimer = requestAnimationFrame(decayAccumulatedScroll);
      } else {
        hideIndicator();
      }
    }
  }

  // Main scroll handler
  function handleScroll() {
    if (transitionTriggered) return;

    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollDelta = currentScrollTop - lastScrollTop;

    isAtBottom = isScrolledToBottom();

    if (isAtBottom && scrollDelta > 0) {
      // User is at bottom and trying to scroll down more
      if (decayTimer) {
        cancelAnimationFrame(decayTimer);
        decayTimer = null;
      }

      accumulatedScroll += scrollDelta * 0.5;
      showIndicator();
      updateProgress((accumulatedScroll / scrollThreshold) * 100);

      if (accumulatedScroll >= scrollThreshold) {
        triggerTransition();
      }
    } else if (!isAtBottom) {
      // User scrolled away from bottom
      if (!decayTimer && accumulatedScroll > 0) {
        decayTimer = requestAnimationFrame(decayAccumulatedScroll);
      }
    }

    lastScrollTop = currentScrollTop;
  }

  // Touch handling for mobile (overscroll detection)
  function handleTouchStart(e) {
    if (transitionTriggered) return;

    // Only check if near bottom (last 30% of page)
    const scrollPercent = (window.pageYOffset + window.innerHeight) / document.documentElement.scrollHeight;
    if (scrollPercent < 0.7) return; // Early return if not near bottom

    touchStartY = e.touches[0].clientY;
    touchMoveAccumulated = 0;
    isTouchingAtBottom = isScrolledToBottom();
  }

  function handleTouchMove(e) {
    if (transitionTriggered) return;

    // Only process if we started near the bottom
    if (!isTouchingAtBottom && touchStartY === 0) return;

    const touchY = e.touches[0].clientY;
    const touchDelta = touchStartY - touchY; // Positive when scrolling down (swiping up)

    // Only check bottom position if we think we're near it
    if (isTouchingAtBottom || touchDelta > 5) {
      const currentlyAtBottom = isScrolledToBottom();

      if ((isTouchingAtBottom || currentlyAtBottom) && touchDelta > 5) {
        // User is at bottom and swiping up (trying to scroll down)
        if (decayTimer) {
          cancelAnimationFrame(decayTimer);
          decayTimer = null;
        }

        // Higher multiplier for faster accumulation on mobile
        touchMoveAccumulated += Math.abs(touchDelta) * 0.8;
        accumulatedScroll = touchMoveAccumulated;

        showIndicator();
        updateProgress((accumulatedScroll / scrollThreshold) * 100);

        if (accumulatedScroll >= scrollThreshold) {
          triggerTransition();
        }

        touchStartY = touchY;
        isTouchingAtBottom = true;
      } else if (!currentlyAtBottom) {
        // User scrolled away from bottom
        isTouchingAtBottom = false;
        if (accumulatedScroll > 0 && !decayTimer) {
          decayTimer = requestAnimationFrame(decayAccumulatedScroll);
        }
      }
    }
  }

  function handleTouchEnd() {
    if (transitionTriggered) return;
    isTouchingAtBottom = false;
    touchStartY = 0; // Reset for next touch

    if (accumulatedScroll > 0 && accumulatedScroll < scrollThreshold) {
      // Decay the accumulated scroll
      decayTimer = requestAnimationFrame(decayAccumulatedScroll);
    }
  }

  // Wheel event for better desktop detection
  function handleWheel(e) {
    if (transitionTriggered) return;

    if (isScrolledToBottom() && e.deltaY > 0) {
      // User is at bottom and scrolling down
      if (decayTimer) {
        cancelAnimationFrame(decayTimer);
        decayTimer = null;
      }

      accumulatedScroll += e.deltaY * 0.3;
      showIndicator();
      updateProgress((accumulatedScroll / scrollThreshold) * 100);

      if (accumulatedScroll >= scrollThreshold) {
        triggerTransition();
      }
    } else if (!isScrolledToBottom() && accumulatedScroll > 0) {
      if (!decayTimer) {
        decayTimer = requestAnimationFrame(decayAccumulatedScroll);
      }
    }
  }

  // Event listeners
  window.addEventListener("scroll", handleScroll, { passive: true });
  window.addEventListener("wheel", handleWheel, { passive: true });
  window.addEventListener("touchstart", handleTouchStart, { passive: true });
  window.addEventListener("touchmove", handleTouchMove, { passive: true });
  window.addEventListener("touchend", handleTouchEnd, { passive: true });
}

// Export utilities for other modules
window.candyBlood = {
  config,
  isInViewport,
  debounce,
  throttle
};
